import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IProcessorDefinitionValuelist extends IModelBase {
  Id: number
  ProcessorDefinitionId: number
  EntityGroupId: number
  Value: string
}

@Injectable()
export class ProcessorDefinitionValuelistODataService extends ODataService<IProcessorDefinitionValuelist> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProcessorDefinitionValuelist'
  }
}
